import { StyleSheet } from '@react-pdf/renderer';

const orderStyles = StyleSheet.create({
  row: {
    flexDirection: 'row'
  },
  column: {
    flexDirection: 'column'
  },
  currency: {
    fontSize: 9
  }
});

export default orderStyles;